import { Fragment } from 'react';
import classNames from 'classnames';
import { formatDate } from 'shared/utils/time/format-date';
import { formatDateDifference } from 'shared/utils/time/format-date-with-difference';
import { isExpiredDate } from 'shared/utils/time/is-expired-date';
import { InvoiceStatus } from 'types/invoice-status';
import styles from './invoice-dates.module.scss';
import type { IDateRow, TInvoiceDatesProps } from './types';

export const InvoiceDates = (props: TInvoiceDatesProps) => {
  const { startPaymentPeriod, endPaymentPeriod, completedDate, status } = props;

  if (status === InvoiceStatus.Cancelled) return null;

  const isCompleted = status === InvoiceStatus.Completed;
  const rows: IDateRow[] = [];

  if (startPaymentPeriod) {
    rows.push({ label: 'Start', value: formatDate(startPaymentPeriod) });
  }

  if (endPaymentPeriod) {
    const endRow: IDateRow = { label: 'End', value: formatDate(endPaymentPeriod) };

    if (!isCompleted) {
      const { isPreExpired, isExpired } = isExpiredDate(endPaymentPeriod);
      endRow.value = formatDateDifference(endPaymentPeriod);
      endRow.className = classNames({ [styles.warning]: isPreExpired, [styles.expired]: isExpired });
    }

    rows.push(endRow);
  }

  if (completedDate) {
    rows.push({
      label: 'Done',
      className: styles.done,
      value:
        isCompleted && endPaymentPeriod
          ? formatDateDifference(endPaymentPeriod, completedDate)
          : formatDate(completedDate),
    });
  }

  if (!rows.length) return <>—</>;

  return (
    <div className={styles.dates}>
      {rows.map(({ label, value, className }) => (
        <Fragment key={label}>
          <span className={styles.secondary}>{label}</span>
          <span className={className}>{value}</span>
        </Fragment>
      ))}
    </div>
  );
};
